import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { ItemInfo, T4ServiceService } from "../../../../../projects/t4core/src/public-api";
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";


@Component({
  selector: 'owa-serviceDialog',
  templateUrl: 'ItemDialog.html',
})

export class ItemDialog extends DialogBase implements OnInit {

  public Item: ItemInfo = new ItemInfo();
  public ItemIdControl: any;
  public ItemId: any;
  public Name: string = "";

  public create: boolean;
  
  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ItemInfo,
    private fb: FormBuilder
  ) {
    super("ItemDialog");

    if (data != null)
      this.Item = data;
  }

  ngOnInit(): void {
    this.ItemId = this.Item?.ItemId;
    this.Name = this.Item?.Name;

    this.form.controls['ItemIdControl'].setValue(this.Item.ItemId);
    this.form.controls['ItemNameControl'].setValue(this.Item.Name);

    }

  public form = new FormGroup({
    ItemIdControl: new FormControl('', [Validators.required]),
    ItemNameControl: new FormControl('', [Validators.required])
  });

  public async save() {

    this.Item.ItemId = this.form.controls['ItemIdControl'].getRawValue();
    this.Item.Name = this.form.controls['ItemNameControl'].getRawValue();

    await this.Api.post<boolean>("/Service/CreateItem", this.Item);

    this.dialogRef.close(true);
  }

  public async update() {

    this.Item.Name = this.form.controls['ItemNameControl'].getRawValue();

    await this.Api.post<boolean>("/Service/UpdateItem", this.Item);

    this.dialogRef.close(true);
  }

}
